/**
 * @file 缓存数据，方便回退后保留现场
 * @author chengong03(chengong03@baidu.com)
 * @date 2018-12-04
 */
/**
 * 使用的临时缓存类型
 *
 * @const
 * @type {string}
 */
var SESSION_METHOD = 'sessionStorage';
/**
 * 使用的永久缓存类型
 *
 * @const
 * @type {string}
 */
var LOCAL_METHOD = 'localStorage';
/**
 * 当存储超过最大限制时，错误 code 为 22
 *
 * @const
 * @type {number}
 */
var QUOTA_EXCEEDED_ERR_CODE = 22;
// localStorage 在低版本 iOS Safari 的隐私模式下无法使用，手机Safari浏览器中具体表现是
// - localStorage对象仍然存在
// - 但是 setItem 会报异常：QuotaExceededError
// - getItem 和 removeItem 直接忽略
/**
 * 缓存列表数据
 *
 * @public
 * @param {string} key key
 * @param {Object} cacheData 数据
 * @param {boolean=} useLocal 是否永久缓存
 * @return {boolean} 是否设置成功
 */
function setCacheData(key, cacheData, useLocal, preKey) {
    if (useLocal === void 0) { useLocal = false; }
    if (preKey === void 0) { preKey = ''; }
    var store = window[useLocal ? LOCAL_METHOD : SESSION_METHOD];
    var fullKey = preKey + key;
    try {
        store.setItem(fullKey, JSON.stringify(cacheData));
        return true;
    }
    catch (e) {
        // 万一存满了，清空后接着存
        if (e.code === QUOTA_EXCEEDED_ERR_CODE) {
            store.clear();
            store.setItem(fullKey, JSON.stringify(cacheData));
            return true;
        }
        return false;
    }
}
/**
 * 取出列表数据
 *
 * @public
 * @param {string} key key
 * @param {boolean=} useLocal 是否永久缓存
 * @return {Object}
 */
function getCacheData(key, useLocal, preKey) {
    if (useLocal === void 0) { useLocal = false; }
    if (preKey === void 0) { preKey = ''; }
    var store = window[useLocal ? LOCAL_METHOD : SESSION_METHOD];
    var fullKey = preKey + key;
    try {
        return store && store.getItem(fullKey)
            ? JSON.parse(store.getItem(fullKey) || '')
            : undefined;
    }
    catch (error) {
        return undefined;
    }
}
/**
 * 清理data缓存
 *
 * @public
 * @param {string} key key
 * @param {boolean=} useLocal 是否永久缓存
 * @return {boolean} 是否设置成功
 */
function delCacheData(key, useLocal, preKey) {
    if (useLocal === void 0) { useLocal = false; }
    if (preKey === void 0) { preKey = ''; }
    var store = window[useLocal ? LOCAL_METHOD : SESSION_METHOD];
    var fullKey = preKey + key;
    try {
        store.removeItem(fullKey);
        return true;
    }
    catch (error) {
        return false;
    }
}
/**
 * 设置对象缓存的信息
 *
 * @param {string} key key
 * @param {string} query query
 * @param {string} val val
 * @param {boolean} useLocal 是否永久缓存
 * @return {boolean} 是否设置成功
 */
function setCacheMeta(key, query, val, useLocal, preKey) {
    if (useLocal === void 0) { useLocal = false; }
    if (preKey === void 0) { preKey = ''; }
    var store = window[useLocal ? LOCAL_METHOD : SESSION_METHOD];
    try {
        var queryObj = JSON.parse(store.getItem(preKey + key) || '""') || {};
        queryObj[query] = val;
        store.setItem(preKey + key, JSON.stringify(queryObj));
        return true;
    }
    catch (error) {
        return false;
    }
}
/**
 * 获取对象缓存的信息
 *
 * @param {string} key key
 * @param {string} query query
 * @param {boolean} useLocal 是否永久缓存
 * @return {string}
 */
function getCacheMeta(key, query, useLocal, preKey) {
    if (useLocal === void 0) { useLocal = false; }
    if (preKey === void 0) { preKey = ''; }
    var store = window[useLocal ? LOCAL_METHOD : SESSION_METHOD];
    try {
        var queryObj = JSON.parse(store.getItem(preKey + key) || '""') || {};
        if (queryObj[query]) {
            return queryObj[query];
        }
        return '';
    }
    catch (error) {
        return '';
    }
}
/**
 * 删除对象缓存的信息
 *
 * @param {string} key key
 * @param {string} query query
 * @param {boolean} useLocal 是否永久缓存
 * @return {boolean} 是否设置成功
 */
function delCacheMeta(key, query, useLocal, preKey) {
    if (useLocal === void 0) { useLocal = false; }
    if (preKey === void 0) { preKey = ''; }
    try {
        setCacheMeta(key, query, '', useLocal, preKey);
        return true;
    }
    catch (error) {
        return false;
    }
}

export { delCacheMeta as a, getCacheMeta as b, setCacheMeta as c, delCacheData as d, getCacheData as g, setCacheData as s };
//# sourceMappingURL=storage-b45bcd44.js.map
